<template>
  <!--  企业库-->
  <div>
    <el-dialog
      :fullscreen="true"
      :show-close="false"
      :visible.sync="dialogFormVisible"
    >
      <div
        @click="handleCancle"
        class="flex justify-between align-center"
        style=""
      >
        <div class="cursor" style="font-size:22px;"><i class="iconfont icon-fanhui text-blue padding-right-sm " style=""></i>企业库</div>
        <i class="el-icon-close" style="font-size:30px"></i>
      </div>
      <div class="header margin-top-sm">
        <div class="input">
          <span>综合查询</span>
          <el-input
            placeholder="综合查询"
            v-model="keyword"
            clearable
            @clear="filterChange"
          ></el-input>
        </div>
        <div class="input">
          <span>省</span>
          <el-select filterable clearable
            class="el_ipt"
            @change="changeId"
            v-model="province"
            placeholder="省"
          >
            <el-option
              v-for="(item, index) in select_list_obj.province_list"
              :key="index"
              :label="item.areaName"
              :value="item.areaId"
            ></el-option>
          </el-select>
        </div>
        <div class="input">
          <span>市</span>
          <el-select filterable clearable class="el_ipt" v-model="city" placeholder="市">
            <el-option
              v-for="(item, index) in select_list_obj.city_list"
              :key="index"
              :label="item.areaName"
              :value="item.areaId"
            ></el-option>
          </el-select>
        </div>

        <el-button type="primary" @click="searchKey">查询</el-button>
        <el-button type="primary" plain @click="searchCancle">取消</el-button>
        <div @click="refresh" class="refresh">
          <i class="el-icon-refresh"></i>
          <div>刷新-共{{ total_records }}条记录</div>
        </div>
        <div space></div>
        <div @click="add" class="btn_add">
          <i class="el-icon-plus"></i>
          新建企业信息
        </div>
      </div>

      <el-table
      :data="tableData"
      style="width: 100%"
      border
      :header-cell-style="{
        background: '#62B3FF',
        color: '#fff',
        'border-color': '#ccc',
      }"
      :cell-style="{ 'border-color': '#ccc' }"
    >
     <el-table-column label="序号" width="80" align="center">
        <template slot-scope="scope">
          {{ (nowPage - 1) * limit + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="用户名" align="center" prop="username">
      </el-table-column>
      <el-table-column label="企业名称" align="center" prop="enterprise_name">
      </el-table-column>
      <el-table-column label="项目联系人" align="center" prop="contacts">
      </el-table-column>
      <el-table-column label="联系人电话" align="center" prop="phone">
      </el-table-column>
      <el-table-column label="法人" align="center" prop="legal_person">
      </el-table-column>

        <el-table-column label="操作" width="300" align="center">
          <template slot-scope="scope">
            <div class="text-blue cursor" @click="handleChoose(scope.row)">
              选择
            </div>
          </template>
        </el-table-column>
      </el-table>

      <BasePagination
        @page_change="page_change"
        :total_records="total_records"
        :max="maxPage"
        :now.sync="nowPage"
        :size.sync="limit"
      ></BasePagination>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: "添加",
    },
    type: {
      type: String,
      default: "add",
    },
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialogFormVisible: true,
      tableData: [],
      keyword: "",
      select: "",
      selectList: [],
      value6: [],
      maxPage: 1,
      nowPage: 1,
      limit:10,
      total_records: 0,
      province: "",
      city: "",
      select_list_obj: {
        province_list: [],
        city_list: [],
      },
    };
  },
  watch: {
    nowPage() {
      this.getData();
    },
    limit() {
      this.getData();
    },
  },
  computed: {},
  methods: {
    page_change(max) {
      this.nowPage = max ? max : 1;
      this.getData();
    },
    filterChange() {
      this.getData();
    },
    searchKey() {
      this.getData();
    },
    searchCancle() {
      this.keyword = "";
      this.province = "";
      this.city = "";
      this.getData();
    },
    refresh() {
      this.getData();
      this.$tools.msg(this.$message,4)
    },
    handleCancle() {
      console.log("handleCancle");
      this.$emit("hide");
    },
    handleChoose({ id }) {
      this.$emit("hide", id);
    },
    add() {
      this.$router.push({
        path: "/EnterpriseLibraryAdd",
      });
    },
    changeId() {
      console.log(this.province);
      this.getCity(this.province);
    },
    // 获取省
    getArea() {
      this.$http
        .post("adminapi/common/area", {
          pid: "-1",
        })
        .then((res) => {
          this.select_list_obj.province_list = res.data;
        })
        .catch((err) => {});
    },
    // 获取区
    getCity(pid) {
      this.$http
        .post("adminapi/common/area", {
          pid,
        })
        .then((res) => {
          this.select_list_obj.city_list = res.data;
        })
        .catch((err) => {});
    },
    // 获取数据
    getData(key) {
      this.$http
        .post("adminapi/enterprise/enterprise/list", {
          page: this.nowPage,
          limit: this.limit,
          keyword: this.keyword,
          province: this.province,
          city: this.city,
        })
        .then((res) => {
          this.tableData = res.data.list;
          this.maxPage = res.data.pages;
          this.total_records = res.data.total_records;
        })
        .catch((err) => {});
    },
  },
  created() {
    this.getData();
    this.getArea();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
// 表格外边框
.el-table td,
.el-table th.is-leaf,
.el-table--border,
.el-table--group {
  border-color: #ccc;
}
.el-table--border::after,
.el-table--group::after,
.el-table::before {
  background-color: #ccc;
}
// fix固定的编辑部分边框显示
::v-deep .el-table__fixed-right::before,
.el-table__fixed::before {
  background-color: #ccc;
}
</style>